import { useState } from 'react';
import AppLayout from '../components/Layout/AppLayout';
import { api } from '../services/api';

export default function InviteColleaguePage() {
  const [email, setEmail]   = useState('');
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState<{ ok: boolean; msg: string } | null>(null);

  async function handleSend(e: React.FormEvent) {
    e.preventDefault();
    setSending(true);
    setResult(null);
    try {
      await api.invite.send(email);
      setResult({ ok: true, msg: 'Meghívó elküldve!' });
      setEmail('');
    } catch (err: unknown) {
      const msg = (err as { message?: string })?.message ?? 'Küldés sikertelen.';
      setResult({ ok: false, msg });
    } finally {
      setSending(false);
    }
  }

  return (
    <AppLayout>
      <div style={{ padding: '40px 40px', maxWidth: 2000 }}>
        <h1 style={{ margin: '0 0 6px', fontSize: 22, fontWeight: 700, color: 'var(--primary)' }}>
          Munkatárs meghívása
        </h1>
        <p style={{ margin: '0 0 28px', fontSize: 14, color: 'var(--muted-foreground)' }}>
          A meghívott személy a cég pályázati adatait is szerkesztheti. A meghívóban szereplő link 7 napig érvényes.
        </p>

        <div style={{ background: '#fff', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: '28px 32px', boxShadow: 'var(--shadow-sm)' }}>
          <form onSubmit={(e) => void handleSend(e)} style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="kolléga@ceg.hu"
              required
              style={{
                flex: 1, minWidth: 220,
                padding: '9px 12px', border: '1px solid var(--border)',
                borderRadius: 'var(--radius-sm)', fontSize: 14, boxSizing: 'border-box',
              }}
            />
            <button
              type="submit"
              disabled={sending}
              style={{
                padding: '9px 22px', background: 'var(--primary)', color: '#fff',
                border: 'none', borderRadius: 'var(--radius-pill)',
                fontWeight: 700, fontSize: 14,
                cursor: sending ? 'default' : 'pointer',
                opacity: sending ? 0.6 : 1,
              }}
            >
              {sending ? 'Küldés…' : 'Meghívó küldése'}
            </button>
          </form>

          {result && (
            <div style={{
              marginTop: 14, padding: '10px 14px', borderRadius: 6, fontSize: 13,
              background: result.ok ? '#f0fdf4' : '#fef2f2',
              color: result.ok ? '#166534' : '#dc2626',
              border: `1px solid ${result.ok ? '#bbf7d0' : '#fca5a5'}`,
            }}>
              {result.msg}
            </div>
          )}
        </div>
      </div>
    </AppLayout>
  );
}
